<template>
  <div class="app-container">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="库存一览" name="stock">
        <div class="head-container">
          <el-input
            v-model="stockQuery.keyword"
            clearable
            size="small"
            placeholder="物料/规则/手柄"
            style="width: 180px; margin-right: 8px;"
            @keyup.enter.native="loadStockList"
          />
          <el-button type="primary" icon="el-icon-search" size="small" @click="loadStockList">查询</el-button>
          <el-button type="success" icon="el-icon-download" size="small" @click="openInDialog">入库</el-button>
          <el-button type="warning" icon="el-icon-upload2" size="small" @click="openOutDialog">打包出库</el-button>
          <el-button size="small" icon="el-icon-link" @click="copyStockBoardLink">复制库存看板链接</el-button>
        </div>
        <el-table v-loading="stockLoading" :data="stockList" size="small" border style="width:100%;margin-top:12px;">
          <el-table-column prop="skuCode" label="物料编码" min-width="150" show-overflow-tooltip />
          <el-table-column label="底部图" width="80" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.ruleImg"
                :src="toFullUrl(scope.row.ruleImg)"
                :preview-src-list="[toFullUrl(scope.row.ruleImg)]"
                fit="contain"
                style="width:40px;height:40px;"
              />
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column prop="ruleName" label="印章底部" min-width="120" show-overflow-tooltip />
          <el-table-column prop="handleName" label="手柄" width="110" show-overflow-tooltip />
          <el-table-column label="手柄图" width="80" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.handleImage"
                :src="toFullUrl(scope.row.handleImage)"
                :preview-src-list="[toFullUrl(scope.row.handleImage)]"
                fit="contain"
                style="width:40px;height:40px;"
              />
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column prop="stockQty" label="当前库存" width="96" align="center">
            <template slot-scope="scope">
              <span :style="{ color: (scope.row.stockQty || 0) <= 0 ? '#f56c6c' : '#303133', fontWeight: 600 }">
                {{ scope.row.stockQty != null ? scope.row.stockQty : 0 }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 16px; text-align: right;"
          background
          layout="total, prev, pager, next, sizes"
          :current-page="stockQuery.page + 1"
          :page-size="stockQuery.size"
          :page-sizes="[10, 20, 50]"
          :total="stockTotal"
          @current-change="(p) => { stockQuery.page = Math.max(p - 1, 0); loadStockList() }"
          @size-change="(s) => { stockQuery.size = s; stockQuery.page = 0; loadStockList() }"
        />
      </el-tab-pane>

      <el-tab-pane label="入库记录" name="in">
        <div class="head-container">
          <el-input
            v-model="inQuery.batchNo"
            clearable
            size="small"
            placeholder="入库批次号"
            style="width: 180px; margin-right: 8px;"
            @keyup.enter.native="loadInList"
          />
          <el-button type="primary" icon="el-icon-search" size="small" @click="loadInList">查询</el-button>
          <el-button type="success" size="small" @click="openInDialog">新建入库</el-button>
        </div>
        <el-table v-loading="inLoading" :data="inList" size="small" border style="width:100%;margin-top:12px;">
          <el-table-column prop="batchNo" label="入库批次" min-width="170" show-overflow-tooltip />
          <el-table-column prop="supplierName" label="供应商/来源" min-width="120" show-overflow-tooltip />
          <el-table-column prop="totalQty" label="合计数量" width="90" align="center" />
          <el-table-column prop="operatorName" label="操作人" width="100" show-overflow-tooltip />
          <el-table-column prop="createTime" label="入库时间" width="170" />
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openInDetail(scope.row)">明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 16px; text-align: right;"
          background
          layout="total, prev, pager, next, sizes"
          :current-page="inQuery.page + 1"
          :page-size="inQuery.size"
          :total="inTotal"
          @current-change="(p) => { inQuery.page = Math.max(p - 1, 0); loadInList() }"
          @size-change="(s) => { inQuery.size = s; inQuery.page = 0; loadInList() }"
        />
      </el-tab-pane>

      <el-tab-pane label="出库记录" name="out">
        <div class="head-container">
          <el-input
            v-model="outQuery.batchNo"
            clearable
            size="small"
            placeholder="出库批次号"
            style="width: 160px; margin-right: 8px;"
            @keyup.enter.native="loadOutList"
          />
          <el-input
            v-model="outQuery.orderNo"
            clearable
            size="small"
            placeholder="订单号"
            style="width: 140px; margin-right: 8px;"
            @keyup.enter.native="loadOutList"
          />
          <el-select
            v-model="outQuery.channel"
            clearable
            size="small"
            placeholder="渠道"
            style="width: 120px; margin-right: 8px;"
          >
            <el-option v-for="c in channels" :key="c.code" :label="c.label" :value="c.code" />
          </el-select>
          <el-button type="primary" icon="el-icon-search" size="small" @click="loadOutList">查询</el-button>
          <el-button type="warning" size="small" @click="openOutDialog">新建出库</el-button>
        </div>
        <el-table v-loading="outLoading" :data="outList" size="small" border style="width:100%;margin-top:12px;">
          <el-table-column prop="batchNo" label="出库批次" min-width="170" show-overflow-tooltip />
          <el-table-column prop="orderNo" label="订单号" min-width="120" show-overflow-tooltip />
          <el-table-column label="渠道" width="96" align="center">
            <template slot-scope="scope">{{ channelLabel(scope.row.channel) }}</template>
          </el-table-column>
          <el-table-column prop="receiverName" label="客户/收件人" min-width="110" show-overflow-tooltip />
          <el-table-column prop="totalQty" label="合计数量" width="90" align="center" />
          <el-table-column prop="createTime" label="出库时间" width="170" />
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openOutDetail(scope.row)">明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 16px; text-align: right;"
          background
          layout="total, prev, pager, next, sizes"
          :current-page="outQuery.page + 1"
          :page-size="outQuery.size"
          :total="outTotal"
          @current-change="(p) => { outQuery.page = Math.max(p - 1, 0); loadOutList() }"
          @size-change="(s) => { outQuery.size = s; outQuery.page = 0; loadOutList() }"
        />
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="印章入库" :visible.sync="inDialogVisible" width="960px" :close-on-click-modal="false">
      <el-form label-width="100px" size="small">
        <el-form-item label="供应商" required>
          <el-select v-model="inForm.supplierId" filterable placeholder="选择供应商" style="width: 100%;" @change="onInSupplierChange">
            <el-option v-for="s in supplierOptions" :key="s.id" :label="s.supplierName + ' (' + s.supplierCode + ')'" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="inForm.remark" type="textarea" :rows="2" maxlength="512" />
        </el-form-item>
        <el-form-item label="入库明细" required>
          <div v-for="(item, idx) in inForm.items" :key="'in-' + idx" class="stock-line">
            <el-select
              v-model="item.ruleId"
              filterable
              placeholder="印章底部"
              style="width: 180px; margin-right: 8px;"
              @change="() => fillInPurchasePrice(item)"
            >
              <el-option v-for="c in ruleOptions" :key="c.id" :label="c.ruleName + ' (' + c.ruleCode + ')'" :value="c.id" />
            </el-select>
            <el-select
              v-model="item.handleId"
              filterable
              placeholder="手柄"
              style="width: 130px; margin-right: 8px;"
              @change="() => fillInPurchasePrice(item)"
            >
              <el-option v-for="h in handleOptions" :key="h.id" :label="h.handleName" :value="h.id" />
            </el-select>
            <el-input-number v-model="item.qty" :min="1" :max="999999" style="width: 110px; margin-right: 8px;" />
            <el-input-number
              v-model="item.purchasePrice"
              :min="0"
              :precision="4"
              :step="0.1"
              placeholder="进货价"
              style="width: 130px; margin-right: 8px;"
            />
            <el-button type="text" style="color:#f56c6c;" @click="removeInLine(idx)">删除</el-button>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="addInLine">添加一行</el-button>
          <div style="color:#909399;font-size:12px;margin-top:6px;">进货价默认取该供应商维护价，可按本单修改</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="inDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="inSubmitting" @click="submitIn">确认入库</el-button>
      </span>
    </el-dialog>

    <el-dialog title="打包出库" :visible.sync="outDialogVisible" width="860px" :close-on-click-modal="false">
      <el-alert
        title="按「印章底部 + 手柄」物料出库，可多行打包。"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 12px;"
      />
      <el-form label-width="100px" size="small">
        <el-form-item label="订单号">
          <el-input v-model="outForm.orderNo" maxlength="128" />
        </el-form-item>
        <el-form-item label="出库渠道" required>
          <el-select v-model="outForm.channel" placeholder="请选择" style="width: 100%;">
            <el-option v-for="c in channels" :key="c.code" :label="c.label" :value="c.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户/收件人">
          <el-input v-model="outForm.receiverName" maxlength="128" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="outForm.remark" type="textarea" :rows="2" maxlength="512" />
        </el-form-item>
        <el-form-item label="出库明细" required>
          <div v-for="(item, idx) in outForm.items" :key="'out-' + idx" class="stock-line">
            <el-select v-model="item.skuId" filterable placeholder="选择物料" style="width: 360px; margin-right: 8px;">
              <el-option
                v-for="s in skuOptions"
                :key="s.id"
                :label="(s.skuName || s.skuCode) + '（库存 ' + (s.stockQty || 0) + '）'"
                :value="s.id"
                :disabled="(s.stockQty || 0) <= 0"
              />
            </el-select>
            <el-input-number v-model="item.qty" :min="1" :max="999999" style="width: 120px; margin-right: 8px;" />
            <el-button type="text" style="color:#f56c6c;" @click="removeOutLine(idx)">删除</el-button>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="addOutLine">添加一行</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="outDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="outSubmitting" @click="submitOut">确认出库</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="detailTitle" :visible.sync="detailVisible" width="720px">
      <el-descriptions v-if="detailHeader" :column="2" size="small" border>
        <el-descriptions-item label="批次号">{{ detailHeader.batchNo }}</el-descriptions-item>
        <el-descriptions-item label="合计数量">{{ detailHeader.totalQty }}</el-descriptions-item>
        <el-descriptions-item v-if="detailHeader.orderNo != null" label="订单号">{{ detailHeader.orderNo || '—' }}</el-descriptions-item>
        <el-descriptions-item v-if="detailHeader.channel" label="渠道">{{ channelLabel(detailHeader.channel) }}</el-descriptions-item>
        <el-descriptions-item v-if="detailHeader.supplierName != null" label="供应商">{{ detailHeader.supplierName || '—' }}</el-descriptions-item>
        <el-descriptions-item label="操作人">{{ detailHeader.operatorName || '—' }}</el-descriptions-item>
        <el-descriptions-item label="时间">{{ detailHeader.createTime || '—' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailHeader.remark || '—' }}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="detailItems" size="small" border style="margin-top:12px;">
        <el-table-column prop="skuCode" label="物料编码" min-width="140" />
        <el-table-column prop="handleName" label="手柄" width="100" />
        <el-table-column prop="ruleName" label="名称" min-width="140" />
        <el-table-column prop="qty" label="数量" width="90" align="center" />
        <el-table-column label="进货价" width="110" align="right">
          <template slot-scope="scope">
            <span v-if="scope.row.purchasePrice != null">{{ Number(scope.row.purchasePrice).toFixed(4) }}</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchSealRules,
  fetchEnabledSealHandles,
  fetchEnabledSealSuppliers,
  fetchSealPurchasePrice,
  fetchSealSkus,
  fetchEnabledSealSkus,
  fetchSealStockChannels,
  fetchSealStockInList,
  fetchSealStockInDetail,
  createSealStockIn,
  fetchSealStockOutList,
  fetchSealStockOutDetail,
  createSealStockOut,
  ensureSealStockBoardToken
} from '@/api/h5-admin-seal-stock'

export default {
  name: 'H5AdminSealStock',
  data() {
    return {
      activeTab: 'stock',
      channels: [],
      ruleOptions: [],
      handleOptions: [],
      supplierOptions: [],
      skuOptions: [],
      stockLoading: false,
      stockList: [],
      stockTotal: 0,
      stockQuery: { page: 0, size: 10, keyword: '' },
      inLoading: false,
      inList: [],
      inTotal: 0,
      inQuery: { page: 0, size: 10, batchNo: '' },
      outLoading: false,
      outList: [],
      outTotal: 0,
      outQuery: { page: 0, size: 10, batchNo: '', orderNo: '', channel: null },
      inDialogVisible: false,
      inSubmitting: false,
      inForm: { supplierId: null, remark: '', items: [{ ruleId: null, handleId: null, qty: 1, purchasePrice: null }] },
      outDialogVisible: false,
      outSubmitting: false,
      outForm: {
        orderNo: '',
        channel: 'TAOBAO',
        receiverName: '',
        remark: '',
        items: [{ skuId: null, qty: 1 }]
      },
      detailVisible: false,
      detailTitle: '明细',
      detailHeader: null,
      detailItems: []
    }
  },
  created() {
    this.loadChannels()
    this.loadStockList()
  },
  methods: {
    toFullUrl(url) {
      if (!url) return ''
      const s = String(url).trim()
      if (/^https?:\/\//i.test(s) || s.startsWith('//') || s.startsWith('data:')) return s
      if (s.indexOf('/upload/') === 0 || s.indexOf('upload/') === 0) {
        return `https://wvxvb.cn/upload/${s.replace(/^\/?upload\/?/, '')}`
      }
      return s
    },
    buildStockBoardLink(token) {
      const origin = window.location.origin
      const base = (process.env.BASE_URL || '/').replace(/\/?$/, '/')
      const prefix = base === '/' ? '' : base.replace(/\/$/, '')
      return `${origin}${prefix}/seal/stock-board?token=${encodeURIComponent(token)}`
    },
    copyStockBoardLink() {
      ensureSealStockBoardToken()
        .then((res) => {
          const data = (res && res.data) || {}
          const token = data.accessToken
          if (!token) {
            this.$message.error('生成看板令牌失败')
            return
          }
          const link = this.buildStockBoardLink(token)
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link).then(() => {
              this.$message.success('库存看板链接已复制（免登录可打开）')
            }).catch(() => {
              this.$alert(link, '请手动复制链接', { confirmButtonText: '关闭' })
            })
          } else {
            this.$alert(link, '请手动复制链接', { confirmButtonText: '关闭' })
          }
        })
        .catch(() => {
          this.$message.error('获取看板链接失败，请确认已执行 stock_board SQL 并重启服务')
        })
    },
    channelLabel(code) {
      const hit = (this.channels || []).find((c) => c.code === code)
      return hit ? hit.label : (code || '—')
    },
    loadChannels() {
      fetchSealStockChannels()
        .then((res) => {
          this.channels = Array.isArray(res.data) ? res.data : []
        })
        .catch(() => {
          this.channels = []
        })
    },
    loadOptions() {
      return Promise.all([
        fetchSealRules({ page: 0, size: 200, status: 1 }).then((res) => {
          const data = (res && res.data) || {}
          this.ruleOptions = data.content || []
        }),
        fetchEnabledSealHandles().then((res) => {
          this.handleOptions = Array.isArray(res.data) ? res.data : []
        }),
        fetchEnabledSealSuppliers().then((res) => {
          this.supplierOptions = Array.isArray(res.data) ? res.data : []
        }),
        fetchEnabledSealSkus().then((res) => {
          this.skuOptions = Array.isArray(res.data) ? res.data : []
        })
      ]).catch(() => {})
    },
    handleTabClick(tab) {
      const name = tab && tab.name
      if (name === 'stock') this.loadStockList()
      if (name === 'in') this.loadInList()
      if (name === 'out') this.loadOutList()
    },
    loadStockList() {
      this.stockLoading = true
      fetchSealSkus({
        page: this.stockQuery.page,
        size: this.stockQuery.size,
        keyword: this.stockQuery.keyword || undefined,
        status: 1
      })
        .then((res) => {
          const data = (res && res.data) || {}
          this.stockList = data.content || []
          this.stockTotal = data.totalElements || 0
        })
        .catch(() => {
          this.stockList = []
          this.stockTotal = 0
        })
        .finally(() => {
          this.stockLoading = false
        })
    },
    loadInList() {
      this.inLoading = true
      fetchSealStockInList({
        page: this.inQuery.page,
        size: this.inQuery.size,
        batchNo: this.inQuery.batchNo || undefined
      })
        .then((res) => {
          const data = (res && res.data) || {}
          this.inList = data.content || []
          this.inTotal = data.totalElements || 0
        })
        .catch(() => {
          this.inList = []
          this.inTotal = 0
        })
        .finally(() => {
          this.inLoading = false
        })
    },
    loadOutList() {
      this.outLoading = true
      fetchSealStockOutList({
        page: this.outQuery.page,
        size: this.outQuery.size,
        batchNo: this.outQuery.batchNo || undefined,
        orderNo: this.outQuery.orderNo || undefined,
        channel: this.outQuery.channel || undefined
      })
        .then((res) => {
          const data = (res && res.data) || {}
          this.outList = data.content || []
          this.outTotal = data.totalElements || 0
        })
        .catch(() => {
          this.outList = []
          this.outTotal = 0
        })
        .finally(() => {
          this.outLoading = false
        })
    },
    openInDialog() {
      this.loadOptions().then(() => {
        const defaultSupplierId = (this.supplierOptions[0] && this.supplierOptions[0].id) || null
        this.inForm = {
          supplierId: defaultSupplierId,
          remark: '',
          items: [{ ruleId: null, handleId: null, qty: 1, purchasePrice: null }]
        }
        this.inDialogVisible = true
      })
    },
    addInLine() {
      this.inForm.items.push({ ruleId: null, handleId: null, qty: 1, purchasePrice: null })
    },
    removeInLine(idx) {
      if (this.inForm.items.length <= 1) {
        this.$message.warning('至少保留一行')
        return
      }
      this.inForm.items.splice(idx, 1)
    },
    onInSupplierChange() {
      ;(this.inForm.items || []).forEach((item) => this.fillInPurchasePrice(item))
    },
    fillInPurchasePrice(item) {
      if (!item || !this.inForm.supplierId || !item.ruleId || !item.handleId) {
        return
      }
      fetchSealPurchasePrice({
        supplierId: this.inForm.supplierId,
        ruleId: item.ruleId,
        handleId: item.handleId
      })
        .then((res) => {
          const data = (res && res.data) || {}
          if (data.purchasePrice != null) {
            this.$set(item, 'purchasePrice', Number(data.purchasePrice))
          }
        })
        .catch(() => {})
    },
    submitIn() {
      if (!this.inForm.supplierId) {
        this.$message.warning('请选择供应商')
        return
      }
      const items = (this.inForm.items || []).filter((i) => i.ruleId && i.handleId && i.qty > 0)
      if (!items.length) {
        this.$message.warning('请选择印章底部与手柄')
        return
      }
      this.inSubmitting = true
      createSealStockIn({
        supplierId: this.inForm.supplierId,
        remark: this.inForm.remark,
        items: items.map((i) => ({
          ruleId: i.ruleId,
          handleId: i.handleId,
          qty: i.qty,
          purchasePrice: i.purchasePrice
        }))
      })
        .then((res) => {
          const header = (res && res.data) || {}
          this.$message.success('入库成功，批次：' + (header.batchNo || ''))
          this.inDialogVisible = false
          this.loadStockList()
          if (this.activeTab === 'in') this.loadInList()
        })
        .finally(() => {
          this.inSubmitting = false
        })
    },
    openOutDialog() {
      this.loadOptions().then(() => {
        this.outForm = {
          orderNo: '',
          channel: 'TAOBAO',
          receiverName: '',
          remark: '',
          items: [{ skuId: null, qty: 1 }]
        }
        this.outDialogVisible = true
      })
    },
    addOutLine() {
      this.outForm.items.push({ skuId: null, qty: 1 })
    },
    removeOutLine(idx) {
      if (this.outForm.items.length <= 1) {
        this.$message.warning('至少保留一行')
        return
      }
      this.outForm.items.splice(idx, 1)
    },
    submitOut() {
      if (!this.outForm.channel) {
        this.$message.warning('请选择出库渠道')
        return
      }
      const items = (this.outForm.items || []).filter((i) => i.skuId && i.qty > 0)
      if (!items.length) {
        this.$message.warning('请选择出库物料')
        return
      }
      this.outSubmitting = true
      createSealStockOut({
        orderNo: this.outForm.orderNo,
        channel: this.outForm.channel,
        receiverName: this.outForm.receiverName,
        remark: this.outForm.remark,
        items
      })
        .then((res) => {
          const header = (res && res.data) || {}
          this.$message.success('出库成功，批次：' + (header.batchNo || ''))
          this.outDialogVisible = false
          this.loadStockList()
          if (this.activeTab === 'out') this.loadOutList()
        })
        .finally(() => {
          this.outSubmitting = false
        })
    },
    openInDetail(row) {
      fetchSealStockInDetail(row.id).then((res) => {
        const data = (res && res.data) || {}
        this.detailTitle = '入库明细'
        this.detailHeader = data.header
        this.detailItems = data.items || []
        this.detailVisible = true
      })
    },
    openOutDetail(row) {
      fetchSealStockOutDetail(row.id).then((res) => {
        const data = (res && res.data) || {}
        this.detailTitle = '出库明细'
        this.detailHeader = data.header
        this.detailItems = data.items || []
        this.detailVisible = true
      })
    }
  }
}
</script>

<style scoped>
.stock-line {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
</style>
